var poll_header_default = {
  "title": "dYVKU",
  "image": "fFEpW",
  "webview": "Q-MTP"
};
export {
  poll_header_default as default
};
//# sourceMappingURL=poll-header-scss.js.map
